import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonDataService } from "src/app/shared/services/common-data.service";
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { CommonService } from 'src/app/shared/services/common.service';
@Injectable({
	providedIn: 'root'
})
export class ReceivingShipmentService {

	constructor(
		private commonDataService: CommonDataService,
		private translateService: TranslateService,
		private commonService: CommonService
	) { }

	isReceivingProcessSuccess(status: string): boolean {
		return (status == this.commonDataService.RECEIVING_SHIPMENT_DEVICES_STATUS.completed.status
				|| status == this.commonDataService.RECEIVING_SHIPMENT_DEVICES_STATUS.gps_not_ready.status);
	}

	getReceivingShipmentDeviceStatus(status: number): boolean {
		return (status == this.commonDataService.RECEIVING_SHIPMENT_DEVICES_STATUS.completed.key
				|| status == this.commonDataService.RECEIVING_SHIPMENT_DEVICES_STATUS.gps_not_ready.key);
	}

	/** ST-2666: "Device connection is rejected: <reasons>" — a reason without a label is shown as its raw code */
	getConnectionRejectionMessage(reasons: string[] = []): string {
		return this.translateService.instant('shipment.connection_rejected', { reasons: this.getConnectionRejectionLabels(reasons) });
	}

	/** ST-2666: one message for a CSV bulk add — "Device connection is rejected for: <serial number> (<reasons>), ..." */
	getDevicesConnectionRejectionMessage(devices: { serial_number?: string, mac_address: string, rejectionReasons: string[] }[]): string {
		const rejectedDevices = devices.map(device =>
			`${device.serial_number || device.mac_address} (${this.getConnectionRejectionLabels(device.rejectionReasons)})`
		);

		return this.translateService.instant('shipment.connection_rejected_devices', { devices: rejectedDevices.join(', ') });
	}

	private getConnectionRejectionLabels(reasons: string[] = []): string {
		return reasons.map(reason => {
			const translationKey = this.commonDataService.DEVICE_CONNECTION_REJECTION_REASONS[reason];
			return translationKey ? this.translateService.instant(translationKey) : reason;
		}).join(', ');
	}

	shipmentDevicesStatus(devices: { [key:string] : any }, status: 'working_on' | 'success' | 'failed') {
		const shipmentStatuses = this.commonDataService.RECEIVING_SHIPMENT_DEVICES_STATUS;

		const notStartedStatuses = [shipmentStatuses.not_start.status, shipmentStatuses.in_progress.status];
		const successStatuses = [shipmentStatuses.completed.status, shipmentStatuses.completed_gps_not_ready.status];
		const failedStatuses = Object.values(shipmentStatuses).map(status => status.status).filter(status => ![...notStartedStatuses, ...successStatuses].includes(status));

		let statuses = [];
		switch (status) {
			case 'working_on':
				statuses = notStartedStatuses;
				break;
			case 'success':
				statuses = successStatuses;
				break;
			case 'failed':
				statuses = failedStatuses;
				break;
			default:
				break;
		}

		let count = 0;

		for (const macAddress in devices) {
			if (statuses.includes(devices[macAddress].status))
				count++;
		}

		return count;
	}

	generateHistoryCsvFile(response, fileName, type) {
		const config = {
			shipment_history: {
				columns: [
					this.translateService.instant('g.serial_number'),
					this.translateService.instant('g.mac_address'),
					this.translateService.instant('shipments_history.shipping_date'),
					this.translateService.instant('ready_to_ship.po_number'),
					this.translateService.instant('shipment.user_name'),
					'SNMAC'
				],
				proccessFormatData: row => row.devices.map(device => [
						device.serial_number,
						device.mac_address,
						row.shipping_date ? row.shipping_date : '-',
						row.purchase_order ? row.purchase_order : '-',
						row.user_name ? row.user_name : '-',
					`${device.serial_number}${device.mac_address}`
				])
			},
			receiving_history: {
				columns: [
					this.translateService.instant('g.mac_address'),
					this.translateService.instant('g.serial_number'),
					this.translateService.instant('g.date'),
					this.translateService.instant('shipment.user_name'),
					this.translateService.instant('shipment.checked_quality'),
					'SNMAC'
				],
				proccessFormatData: row => [[
					row.mac_address,
					row.serial_number,
					row.action_time,
					row.user_name,
					row.checked_quality,
					row.sn_mac
				]]
			}
		};

		const getFileHeaderCsv = this.commonService.getCsvFileHeadersInfo({});
		const { columns, proccessFormatData } = config[type];
		const csvRows = [...getFileHeaderCsv, columns];

		(response || []).forEach(row => {
			const processedRows = proccessFormatData(row);
			csvRows.push(...processedRows);
		});

		new AngularCsv(csvRows, fileName);
	}

}

